import { PluginSetup as Translation } from '@leverege/api-ui-i18n-management'
import { PluginSetup as UserManagement } from '@leverege/api-ui-user-management' 
import { PluginSetup as LoginSetup } from '@leverege/api-ui-login'

export default {
  install( plg ) {
    Translation.install( plg )
    UserManagement.install( plg )
    LoginSetup.install( plg )
  }
}
